import React from 'react';
import useBrandName from 'src/hooks/use-brand-name';

interface Props {
  criterionType: string;
  displayString: string;
}

const Criterion = ({criterionType, displayString}: Props) => {
  const brandName = useBrandName();

  if (!brandName) {
    return null;
  }

  return (
    <div className="flex-row">
      <span>{criterionType.replace(/Raise Me/g, brandName)}</span>
      <strong>{displayString}</strong>
    </div>
  );
};

export default Criterion;
